// ...existing code...
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.slideshow__slide .display-l').forEach(el => {
      el.innerHTML += " DON'T SLEEP.";
    });
  }
  
});


document.addEventListener('DOMContentLoaded', function() {
  const target = document.querySelector('.footer__aside .h-stack.gap-5.md\\:justify-start');
  const constrainedImage = document.querySelector('.constrained-image');
  if (target && constrainedImage && constrainedImage.parentNode) {
    constrainedImage.parentNode.insertBefore(target, constrainedImage.nextSibling);
  }
});
// ...existing code...

// Added code: insert or create .arrow-head SVG into anchors inside .announcement-bar__message-list .subheading
document.addEventListener('DOMContentLoaded', function () {
  function getOrCreateArrowSVG() {
    const existing = document.querySelector('svg.arrow-head');
    if (existing) return existing;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = '<svg class="arrow-head" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M2.224 7.33336H11.948L8.41933 3.80469L9.362 2.86202L14.5 8.00002L9.362 13.138L8.41933 12.1954L11.948 8.66669H2.224V7.33336Z" fill="#E8AC1E"/></svg>';
    return wrapper.firstElementChild;
  }

  function insertArrowIntoAnchors() {
    const anchors = document.querySelectorAll('.announcement-bar__message-list .subheading a');
    if (!anchors || anchors.length === 0) return;
    const source = getOrCreateArrowSVG();
    anchors.forEach(a => {
      if (!a.querySelector('svg.arrow-head')) {
        a.appendChild(source.cloneNode(true));
      }
    });
  }

  insertArrowIntoAnchors();

  // Observe changes (carousel/content swaps) and re-run
  const list = document.querySelector('.announcement-bar__message-list');
  if (list) {
    const mo = new MutationObserver(insertArrowIntoAnchors);
    mo.observe(list, { childList: true, subtree: true, attributes: false });
  }

  // Also re-run on window load in case assets load later
  window.addEventListener('load', insertArrowIntoAnchors);
});

// Loox widget style enforcer - wait for Loox to load and force styles
(function() {
  function applyLooxStyles() {
    const looxTitles = document.querySelectorAll('.loox-widget .grid-item .block.title');
    if (looxTitles.length > 0) {
      looxTitles.forEach(title => {
        title.style.cssText = `
          display: none !important;
          color: var(--text-primary, #121212) !important;
          font-family: var(--Typfaces-Secondary, Montserrat) !important;
          font-size: var(--typography-body-b1-size, 18px) !important;
          font-style: normal !important;
          font-weight: 500 !important;
          line-height: var(--typography-body-b1-lh, 26px) !important;
          letter-spacing: var(--typography-body-b1-spacing, 0) !important;
        `;
      });
    }
  }

  // Try immediately
  applyLooxStyles();

  // Try after DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLooxStyles);
  }

  // Try after full page load
  window.addEventListener('load', function() {
    setTimeout(applyLooxStyles, 500);
    setTimeout(applyLooxStyles, 1000);
    setTimeout(applyLooxStyles, 2000);
  });

  // Watch for Loox widget being added to DOM
  if (typeof MutationObserver !== 'undefined' && document.body) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          const hasLooxWidget = Array.from(mutation.addedNodes).some(node =>
            node.nodeType === 1 && (
              node.classList?.contains('loox-widget') ||
              node.querySelector?.('.loox-widget')
            )
          );
          if (hasLooxWidget) {
            setTimeout(applyLooxStyles, 100);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

// Product card size selector dynamic positioning
(function() {
  function measureAndSetHeight(card) {
    const sizeSelector = card.querySelector('.product-card__floating-size-selector');
    const figure = card.querySelector('.product-card__figure');

    if (sizeSelector && figure) {
      // Force display to measure accurately
      const originalVisibility = sizeSelector.style.visibility;
      const originalOpacity = sizeSelector.style.opacity;
      const originalDisplay = sizeSelector.style.display;

      sizeSelector.style.visibility = 'visible';
      sizeSelector.style.opacity = '0';
      sizeSelector.style.display = 'grid';

      // Force reflow to ensure measurement is accurate
      void sizeSelector.offsetHeight;

      // Measure the height
      const height = sizeSelector.offsetHeight;


      // Restore original state
      sizeSelector.style.visibility = originalVisibility;
      sizeSelector.style.opacity = originalOpacity;
      sizeSelector.style.display = originalDisplay;

      // Set CSS variable on the card with a small gap
      if (height > 0) {
        card.style.setProperty('--size-selector-height', `${height - 20}px`);
      }
    }
  }

  function updateAllCards() {
    const productCards = document.querySelectorAll('product-card');
    productCards.forEach(card => measureAndSetHeight(card));
  }

  // Add hover listeners to each card to update on demand
  function initializeCards() {
    const productCards = document.querySelectorAll('product-card');

    productCards.forEach(card => {
      const figure = card.querySelector('.product-card__figure');

      if (figure && !figure.dataset.sizeSelectorInit) {
        figure.dataset.sizeSelectorInit = 'true';

        // Measure on first hover
        figure.addEventListener('mouseenter', function() {
          measureAndSetHeight(card);
        }, { once: false });
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateAllCards();
      initializeCards();
    });
  } else {
    updateAllCards();
    initializeCards();
  }

  // Run after images load (can affect height)
  window.addEventListener('load', function() {
    updateAllCards();
    initializeCards();
  });

  // Update on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllCards, 250);
  });

  // Watch for dynamically added product cards
  function setupObserver() {
    if (typeof MutationObserver !== 'undefined' && document.body) {
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            const hasProductCard = Array.from(mutation.addedNodes).some(node =>
              node.nodeType === 1 && (
                node.tagName === 'PRODUCT-CARD' ||
                node.querySelector?.('product-card')
              )
            );
            if (hasProductCard) {
              shouldUpdate = true;
            }
          }
        });
        if (shouldUpdate) {
          setTimeout(function() {
            updateAllCards();
            initializeCards();
          }, 100);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();
// ...existing code...